import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5_sass@1.99.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5_sass@1.99.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackToPreviousBlock"] */ "/microservice/src/app/components/blocks/back-to-previous/client.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/blocks/category-cards/category-cards.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryCardsBlock"] */ "/microservice/src/app/components/blocks/category-cards/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunityBuzzCarouselBlock"] */ "/microservice/src/app/components/blocks/community-buzz-carousel/client.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/blocks/community-buzz-carousel/community-buzz-carousel.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ConsumableProductDetailBlock"] */ "/microservice/src/app/components/blocks/consumable-product-detail/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DurableProductDetailsBlock"] */ "/microservice/src/app/components/blocks/durable-product-details/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EvergreenCommunityBlock"] */ "/microservice/src/app/components/blocks/evergreen-community/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedCardBlock"] */ "/microservice/src/app/components/blocks/featured-card/client.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/blocks/featured-offers/featured-offers.module.scss");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/blocks/featured-home-section/featured-home-section.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProductRecipeCard"] */ "/microservice/src/app/components/blocks/featured-product-recipe-card/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FiftyFiftyBlock"] */ "/microservice/src/app/components/blocks/fifty-fifty/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FindPartyAndConsultantBlock"] */ "/microservice/src/app/components/blocks/find-party-or-consultant/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuaranteeBlock"] */ "/microservice/src/app/components/blocks/guarantee/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroBannerBlock"] */ "/microservice/src/app/components/blocks/hero-banner/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageListBlock"] */ "/microservice/src/app/components/blocks/image-list/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MeetYourConsultantBlock"] */ "/microservice/src/app/components/blocks/meet-your-consultant/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferCardGalleryBlock"] */ "/microservice/src/app/components/blocks/offer-card-gallery/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferCardShowcaseBlock"] */ "/microservice/src/app/components/blocks/offer-card-showcase/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferHeroBlock"] */ "/microservice/src/app/components/blocks/offer-hero/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCarouselBlock"] */ "/microservice/src/app/components/blocks/product-carousel/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailBannerBlock"] */ "/microservice/src/app/components/blocks/product-detail-banner/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReplacementPartBlock"] */ "/microservice/src/app/components/blocks/replacement-part/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SlimBannerBlock"] */ "/microservice/src/app/components/blocks/slim-banner/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionBasedCardBlock"] */ "/microservice/src/app/components/blocks/solution-based-card/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextIntroBlock"] */ "/microservice/src/app/components/blocks/text-intro/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatsIncludedBlock"] */ "/microservice/src/app/components/blocks/whats-included/client.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/client/index.ts");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/shared/error-boundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterBlock"] */ "/microservice/src/app/components/shared/footer/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBlock"] */ "/microservice/src/app/components/shared/header/client.tsx");
